// 获取banner图
import { getBannerList } from '@/api/common.js';
import { $data } from '@/setting/data';
export function getBannerCommon(id) {
    return getBannerList(id).then(res => {
        return res.data;
    })
}
// 进列表页
export function gotoListPage(data, router) {
    if (!data.link) return;
    let url = window.location.href;
    if (data.link.includes('products')) {
        let path = `/products/${$data.tab2[data.title]}`;
        if (url.includes('?')) {
            const queryString = url.split('?')[1];
            const params = queryString.split('&');
            const filteredParams = params.filter(param => !param.startsWith('key='));
            if (filteredParams.length > 0) {
                path = `/products/${$data.tab2[data.title]}?${filteredParams.join('&')}`;
            }
        }
        const routeData = router.resolve({
            path: path
        });
        window.open(routeData.href);
    } else {
        let path = data.link;
        if (url.includes('?')) {
            const queryString = url.split('?')[1];
            const params = queryString.split('&');
            const filteredParams = params.filter(param => !param.startsWith('key='));
            if (filteredParams.length > 0) {
                path = `${data.link}?${filteredParams.join('&')}`;
            }
        }
        const routeData = router.resolve({
            path: path
        });
        window.open(routeData.href);
    }
}
// 轮播图点击事件
export function bannerClick(data) {
    console.log(data);
}
// 修改页面标题等内容
export function changePageInfo(title, keywords, description) {
    document.title = title;
    document.keywords = keywords;
    document.description = description;
}
// gio事件
export function gioAction(tag, params) {
    if (window.gio && typeof window.gio === 'function') {
        try {
            if (params) {
                window.gio('track', tag, params);
            } else {
                window.gio('track', tag);
            }
        } catch (error) {
            console.error('GIO tracking error:', error);
        }
    } else {
        console.warn('GIO SDK not loaded or not available');
    }
}